export const germanFormat = function(number, options) {
  /** @type {Array.<string>} */
    var result = (options['fraction'] ? number.toFixed(options['fraction']) : '' + number).split('.');
    return options['prefix'] +
      result[0].replace(/\B(?=(\d{3})+(?!\d))/g,
      /** @type {string} */ (options['grouping'])) +
      (result[1] ? options['decimal'] + result[1] : '') +
      options['suffix'];
  }